import { Link } from "react-router-dom";
import heroImage from "../assets/about-hero-4.jpg";
import office1 from "../assets/lady-justice-parallax.webp";
import office2 from "../assets/aboutimage3.jpg";
import missionImage from "../assets/aboutimage1.jpg";
import visionImage from "../assets/aboutimage3.jpg";
import aboutparallax from "../assets/lady-justice.jpg";
//practice area images
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import litigationImg from "../assets/litigation.png";
import landImg from "../assets/land-law-conveyancing.jpg";
import criminalImg from "../assets/criminal-law-hero.webp";
import consultancy from "../assets/consultancy.png";
import commercial from "../assets/commercial-property-hero.jpg";
import family from "../assets/family -law.webp";
import clientJourneyImage from "../assets/aboutimage3.jpg"
import feeImage from "../assets/lady-justice2.jpg"
 
const CoreValues = () => {
  const [text, setText] = useState("");

  const fullText = "Core Values";

  const values = [
    { title: "Integrity", desc: "We act with honesty and strong ethical principles." },
    { title: "Confidentiality", desc: "Client information is always protected." },
    { title: "Professionalism", desc: "We deliver legal services with excellence." },
    { title: "Client Commitment", desc: "We prioritize client success in every case." },
    { title: "Excellence", desc: "We pursue accuracy and strong legal outcomes." },
    { title: "Justice", desc: "We uphold fairness and the rule of law." },
  ];

  // TYPEWRITER EFFECT
  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      setText(fullText.slice(0, i));
      i++;
      if (i > fullText.length) clearInterval(interval);
    }, 120);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-28 px-6 md:px-16 bg-[#F8F8F8]">

      {/* HEADER */}
      <div className="text-center max-w-3xl mx-auto mb-20">

        {/* TYPEWRITER TITLE */}
        <h2 className="text-5xl font-bold text-[#0B1C39] min-h-[60px]">
          {text}
          <span className="animate-pulse text-yellow-500">|</span>
        </h2>

        <p className="text-gray-600 mt-6">
          Principles that define how we serve justice and our clients.
        </p>

      </div>

      {/* VALUES GRID */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">

        {values.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.15 }}
            viewport={{ once: true }}
            className="bg-white p-8 rounded-2xl shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-yellow-500"
          >
            <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
              {item.title}
            </h3>

            <p className="text-gray-600 leading-relaxed">
              {item.desc}
            </p>
          </motion.div>
        ))}

      </div>
    </section>
  );
};


const PracticeAreas = () => {
  const areas = [
   
    {
      title: "Litigation & Dispute Resolution",
      image: litigationImg,
      path: "/services/litigation",
    },
    {
      title: "Conveyance & Real Estate",
      image: landImg,
      path: "/services/conveyancing",
    },
     {
        title: "Corporate & Commercial Law",
        image: commercial,
        link: "/services/commercial",
      },
    {
      title: "Criminal Defence",
      image: criminalImg,
      path: "/services/criminal",
    },
    {
      title: "General Legal Consultancy",
      image: consultancy,
      path: "/services/intellectual",
    },
    {
      title: "Family & Succession Law",
      image: family,
      path: "/services/probate",
    },
  ];

  return (
    <section className="py-28 px-6 md:px-16 bg-white">

      {/* HEADER */}
      <div className="text-center max-w-3xl mx-auto mb-20">

        <p className="text-yellow-600 font-semibold uppercase tracking-[6px] mb-4">
          Areas of Expertise
        </p>

        <h2 className="text-4xl md:text-5xl font-bold text-[#0B1C39]">
          Practice Areas
        </h2>

        <p className="text-gray-600 mt-6 leading-relaxed max-w-3xl mx-auto">
  We have advocates specialized in diverse areas of legal practice. 
  As a full-service law firm, we embrace a holistic approach to legal 
  service provision, ensuring that every client receives strategic, 
  reliable, and personalized legal support. Whatever legal matter you 
  present to us, our team is committed to guiding you every step of 
  the way toward effective solutions.
</p>
      </div>

      {/* IMAGE GRID */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">

        {areas.map((item, index) => (
          <Link
            to={item.path}
            key={index}
            className="relative group h-[280px] overflow-hidden rounded-2xl shadow-lg"
          >

            {/* IMAGE */}
            <img
              src={item.image}
              alt={item.title}
              className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
            />

            {/* DARK OVERLAY */}
            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition"></div>

            {/* TITLE */}
            <div className="absolute inset-0 flex items-center justify-center">
              <h3 className="text-white text-lg md:text-xl font-semibold text-center px-4">
                {item.title}
              </h3>
            </div>

          </Link>
        ))}

      </div>

    </section>
  );
};

function About() {
  return (
    <>
      {/* ================= HERO ================= */}
      <section className="relative h-[80vh] flex items-center justify-center">

        {/* BACKGROUND IMAGE */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${heroImage})`,
          }}
        ></div>

        {/* DARK OVERLAY */}
        <div className="absolute inset-0 bg-black/70"></div>

        {/* QUOTE CONTENT */}
        <div className="relative z-10 text-center text-white px-6 max-w-4xl">

          <h1 className="text-3xl md:text-3xl font-dancing-script leading-relaxed">
            “Throughout history, it has been the inaction of those who could have acted,
            the indifference of those who should have known better, the silence of the
            voice of justice when it mattered most.”
          </h1>

          <p className="mt-6 text-gray-200 text-lg">
            — Haile Selassie
          </p>

        </div>

      </section>

      {/* ================= FIRM BACKGROUND ================= */}
      <section className="py-24 px-6 md:px-16 bg-white">

        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">

          {/* LEFT SIDE IMAGES */}
          <div className="relative h-[500px]">

            {/* MAIN IMAGE */}
            <img
              src={office1}
              alt="Law Firm Office"
              className="w-[80%] h-[420px] object-cover rounded-2xl shadow-2xl"
            />

            {/* OVERLAPPING IMAGE */}
            <img
              src={office2}
              alt="Lawyers Meeting"
              className="absolute bottom-0 right-0 w-[55%] h-[250px] object-cover rounded-2xl border-8 border-white shadow-2xl"
            />

          </div>

          {/* RIGHT SIDE CONTENT */}
          <div>

            <p className="text-yellow-600 font-semibold uppercase tracking-widest mb-3">
              Who we are-The Genesis Of Gati
            </p>

            <h2 className="text-4xl md:text-5xl font-bold text-[#0B1C39] leading-tight mb-6">
              Our Origin Story 
            </h2>

<div className="text-gray-600 leading-relaxed mb-6 space-y-5">

  <p>
    <strong>GATI & CO. ADVOCATES</strong> was established in the heart of Nakuru City,
    Kenya’s fourth-largest urban centre and the economic nerve of the Rift Valley.
    Unlike firms that transplant Nairobi-style legal services into upcountry towns,
    we are <strong>indigenously Nakuru-rooted</strong> but nationally-minded.
  </p>

  <div>
    <h3 className="text-xl font-semibold text-[#0B1C39] mb-3">
      Our Legal Identity
    </h3>

    <ul className="space-y-3 list-disc pl-6">
      <li>
        A fully registered law firm under the <strong>Law Society of Kenya</strong> (LSK)
      </li>

      <li>
        Licensed by the <strong> Kenya School of Law</strong>  and compliant with all advocates’
        professional indemnity requirements
      </li>

      <li>
        Operates from <strong>Plutos House</strong>  — a strategic, secure, and accessible commercial
        hub near Nakuru Law Courts and key government registries
      </li>
    </ul>
  </div>

</div>
            <p className="text-gray-600 leading-relaxed mb-6">
              Our approach is client-focused, ensuring that every matter is handled
              with care, precision, and commitment to achieving the best possible
              outcome for our clients.
            </p>

            <p className="text-gray-600 leading-relaxed">
              Over the years, we have built a strong reputation for excellence in
              legal practice across multiple areas of law including corporate,
              property, litigation, and advisory services. Our team combines legal
              expertise with strategic thinking to help clients navigate complex
              legal challenges with confidence and clarity.
            </p>

          </div>

        </div>

      </section>
      {/* ================= MISSION & VISION ================= */}
<section className="py-24 px-6 md:px-16 bg-[#F8F8F8]">

  <div className="max-w-7xl mx-auto">

    {/* SECTION HEADING */}
    <div className="text-center mb-20">

      <p className="text-yellow-600 font-semibold uppercase tracking-[5px] mb-4">
        Guiding Principles
      </p>

      <h2 className="text-4xl md:text-5xl font-bold text-[#0B1C39]">
        Mission & Vision
      </h2>

    </div>

    {/* CARDS */}
    <div className="grid lg:grid-cols-2 gap-10">

      {/* ================= MISSION CARD ================= */}
      <div className="relative h-[500px] rounded-[30px] overflow-hidden group shadow-2xl">

        {/* IMAGE */}
        <img
          src={missionImage}
          alt="Mission"
          className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
        />

        {/* DARK OVERLAY */}
        <div className="absolute inset-0 bg-black/65"></div>

        {/* CONTENT */}
        <div className="absolute inset-0 p-10 md:p-14 flex flex-col justify-end">

          {/* SMALL LABEL */}
          <p className="text-yellow-500 uppercase tracking-[4px] text-sm mb-4">
            Our Commitment
          </p>

          {/* TITLE */}
          <h3 className="text-4xl font-bold text-white mb-6">
            Our Mission
          </h3>

          {/* TEXT */}
          <p className="text-gray-200 leading-relaxed text-lg">
            To provide trusted, strategic, and client-focused legal services
            while upholding integrity, professionalism, and justice in every
            matter we handle.
          </p>

        </div>

      </div>

      {/* ================= VISION CARD ================= */}
      <div className="relative h-[500px] rounded-[30px] overflow-hidden group shadow-2xl">

        {/* IMAGE */}
        <img
          src={visionImage}
          alt="Vision"
          className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
        />

        {/* DARK OVERLAY */}
        <div className="absolute inset-0 bg-black/65"></div>

        {/* CONTENT */}
        <div className="absolute inset-0 p-10 md:p-14 flex flex-col justify-end">

          {/* SMALL LABEL */}
          <p className="text-yellow-500 uppercase tracking-[4px] text-sm mb-4">
            Future Direction
          </p>

          {/* TITLE */}
          <h3 className="text-4xl font-bold text-white mb-6">
            Our Vision
          </h3>

          {/* TEXT */}
          <p className="text-gray-200 leading-relaxed text-lg">
            To become a leading law firm recognized for legal excellence,
            innovation, and unwavering commitment to client success across
            every area of practice.
          </p>

        </div>

      </div>

    </div>

  </div>

</section>
{/* ================= THE GATI DOCTRINE ================= */}
<section className="py-24 px-6 md:px-16 bg-[#F8F8F8]">

  <div className="max-w-7xl mx-auto">

    {/* SECTION HEADING */}
    <div className="text-center mb-20">

      <p className="text-yellow-600 font-semibold uppercase tracking-[5px] mb-4">
        Our Philosophy
      </p>

      <h2 className="text-4xl md:text-5xl font-bold text-[#0B1C39]">
        The Gati Doctrine
      </h2>

      <p className="mt-5 text-gray-500 text-lg max-w-xl mx-auto leading-relaxed">
        Five immutable principles that govern every matter we handle — without exception.
      </p>

    </div>

    {/* PRINCIPLES GRID */}
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">

      {/* CARD 1 */}
      <div className="group relative bg-white rounded-[24px] p-10 shadow-md hover:shadow-2xl border border-transparent hover:border-yellow-400 transition-all duration-500 overflow-hidden">

        {/* BIG NUMBER WATERMARK */}
        <span className="absolute -top-4 -right-2 text-[7rem] font-black text-[#0B1C39]/[0.04] leading-none select-none pointer-events-none">
          01
        </span>

        {/* ICON DOT */}
        <div className="w-12 h-12 rounded-full bg-yellow-400/20 flex items-center justify-center mb-8 group-hover:bg-yellow-400 transition-colors duration-300">
          <div className="w-3 h-3 rounded-full bg-yellow-500 group-hover:bg-white transition-colors duration-300"></div>
        </div>

        {/* LABEL */}
        <p className="text-yellow-600 uppercase tracking-[4px] text-xs font-semibold mb-3">
          48-Hour Rule
        </p>

        {/* TITLE */}
        <h3 className="text-xl font-bold text-[#0B1C39] mb-4 leading-snug">
          Movement Over Stagnation
        </h3>

        {/* DIVIDER */}
        <div className="w-10 h-[2px] bg-yellow-400 mb-5 group-hover:w-full transition-all duration-500"></div>

        {/* TEXT */}
        <p className="text-gray-500 leading-relaxed text-base">
          No matter sits unattended for more than 48 hours without a status update to the client.
        </p>

      </div>

      {/* CARD 2 */}
      <div className="group relative bg-white rounded-[24px] p-10 shadow-md hover:shadow-2xl border border-transparent hover:border-yellow-400 transition-all duration-500 overflow-hidden">

        <span className="absolute -top-4 -right-2 text-[7rem] font-black text-[#0B1C39]/[0.04] leading-none select-none pointer-events-none">
          02
        </span>

        <div className="w-12 h-12 rounded-full bg-yellow-400/20 flex items-center justify-center mb-8 group-hover:bg-yellow-400 transition-colors duration-300">
          <div className="w-3 h-3 rounded-full bg-yellow-500 group-hover:bg-white transition-colors duration-300"></div>
        </div>

        <p className="text-yellow-600 uppercase tracking-[4px] text-xs font-semibold mb-3">
          Plain Language
        </p>

        <h3 className="text-xl font-bold text-[#0B1C39] mb-4 leading-snug">
          Clarity Over Mystique
        </h3>

        <div className="w-10 h-[2px] bg-yellow-400 mb-5 group-hover:w-full transition-all duration-500"></div>

        <p className="text-gray-500 leading-relaxed text-base">
          Every legal concept is explained in plain English or Kiswahili. You will never be confused.
        </p>

      </div>

      {/* CARD 3 */}
      <div className="group relative bg-white rounded-[24px] p-10 shadow-md hover:shadow-2xl border border-transparent hover:border-yellow-400 transition-all duration-500 overflow-hidden">

        <span className="absolute -top-4 -right-2 text-[7rem] font-black text-[#0B1C39]/[0.04] leading-none select-none pointer-events-none">
          03
        </span>

        <div className="w-12 h-12 rounded-full bg-yellow-400/20 flex items-center justify-center mb-8 group-hover:bg-yellow-400 transition-colors duration-300">
          <div className="w-3 h-3 rounded-full bg-yellow-500 group-hover:bg-white transition-colors duration-300"></div>
        </div>

        <p className="text-yellow-600 uppercase tracking-[4px] text-xs font-semibold mb-3">
          3 Moves Ahead
        </p>

        <h3 className="text-xl font-bold text-[#0B1C39] mb-4 leading-snug">
          Strategy Over Reaction
        </h3>

        <div className="w-10 h-[2px] bg-yellow-400 mb-5 group-hover:w-full transition-all duration-500"></div>

        <p className="text-gray-500 leading-relaxed text-base">
          We plan three moves ahead — anticipating opposing counsel, court delays, or registry issues.
        </p>

      </div>

      {/* CARD 4 */}
      <div className="group relative bg-white rounded-[24px] p-10 shadow-md hover:shadow-2xl border border-transparent hover:border-yellow-400 transition-all duration-500 overflow-hidden">

        <span className="absolute -top-4 -right-2 text-[7rem] font-black text-[#0B1C39]/[0.04] leading-none select-none pointer-events-none">
          04
        </span>

        <div className="w-12 h-12 rounded-full bg-yellow-400/20 flex items-center justify-center mb-8 group-hover:bg-yellow-400 transition-colors duration-300">
          <div className="w-3 h-3 rounded-full bg-yellow-500 group-hover:bg-white transition-colors duration-300"></div>
        </div>

        <p className="text-yellow-600 uppercase tracking-[4px] text-xs font-semibold mb-3">
          Radical Honesty
        </p>

        <h3 className="text-xl font-bold text-[#0B1C39] mb-4 leading-snug">
          Justice Over Revenue
        </h3>

        <div className="w-10 h-[2px] bg-yellow-400 mb-5 group-hover:w-full transition-all duration-500"></div>

        <p className="text-gray-500 leading-relaxed text-base">
          If a matter has no merit, we will tell you upfront. We do not milk clients.
        </p>

      </div>

      {/* CARD 5 — spans 2 cols on lg to balance the grid */}
      <div className="group relative bg-[#0B1C39] rounded-[24px] p-10 shadow-md hover:shadow-2xl border border-transparent hover:border-yellow-400 transition-all duration-500 overflow-hidden lg:col-span-2">

        <span className="absolute -top-4 -right-4 text-[7rem] font-black text-white/[0.04] leading-none select-none pointer-events-none">
          05
        </span>

        <div className="w-12 h-12 rounded-full bg-yellow-400/20 flex items-center justify-center mb-8 group-hover:bg-yellow-400 transition-colors duration-300">
          <div className="w-3 h-3 rounded-full bg-yellow-400 group-hover:bg-white transition-colors duration-300"></div>
        </div>

        <p className="text-yellow-400 uppercase tracking-[4px] text-xs font-semibold mb-3">
          Rift Valley Roots
        </p>

        <h3 className="text-xl font-bold text-white mb-4 leading-snug">
          Local Soul, National Standard
        </h3>

        <div className="w-10 h-[2px] bg-yellow-400 mb-5 group-hover:w-full transition-all duration-500"></div>

        <p className="text-gray-400 leading-relaxed text-base max-w-2xl">
          We combine deep Rift Valley knowledge with best-in-class legal drafting and procedure.
        </p>

      </div>

    </div>

  </div>

</section>
{/* ================= CLIENT JOURNEY ================= */}
<section className="py-28 px-6 md:px-16 bg-[#F8F8F8] overflow-hidden">

  <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">

    {/* ================= LEFT IMAGE ================= */}
    <div className="relative">

      {/* MAIN IMAGE */}
      <div className="relative rounded-[32px] overflow-hidden shadow-2xl">

        <img
          src={clientJourneyImage}
          alt="Client Journey"
          className="w-full h-[750px] object-cover"
        />

        {/* GRADIENT OVERLAY */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B1C39]/70 via-transparent to-transparent"></div>

      </div>

      {/* FLOATING CARD */}
      <div className="absolute -bottom-10 -right-6 bg-white rounded-[24px] shadow-2xl p-8 max-w-[280px] border border-gray-100">

        <p className="text-yellow-600 uppercase tracking-[4px] text-xs font-semibold mb-3">
          Client Commitment
        </p>

        <h3 className="text-2xl font-bold text-[#0B1C39] mb-4">
          Clear. Strategic. Responsive.
        </h3>

        <p className="text-gray-600 leading-relaxed">
          Every client matter follows a structured process designed for clarity,
          speed, and confidence from beginning to resolution.
        </p>

      </div>

    </div>

    {/* ================= RIGHT CONTENT ================= */}
    <div>

      {/* SECTION HEADER */}
      <div className="mb-14">

        <p className="text-yellow-600 uppercase tracking-[6px] font-semibold mb-4">
          We are here to help you
        </p>

        <h2 className="text-4xl md:text-5xl font-bold text-[#0B1C39] leading-tight mb-6">
          The Client Journey
        </h2>

        <p className="text-gray-600 text-lg leading-relaxed">
          From your first call to final resolution, we maintain a process built
          on transparency, communication, and strategic legal execution.
        </p>

      </div>

      {/* STEPS */}
      <div className="space-y-8">

        {/* STEP 1 */}
        <div className="group flex gap-6">

          {/* NUMBER */}
          <div className="flex-shrink-0">

            <div className="w-16 h-16 rounded-full bg-[#0B3D91] text-white flex items-center justify-center text-xl font-bold shadow-lg group-hover:scale-110 transition duration-300">
              01
            </div>

          </div>

          {/* CONTENT */}
          <div>

            <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
              Intake <span className="text-yellow-600">(Same Day)</span>
            </h3>

            <p className="text-gray-600 leading-relaxed">
              Call <span className="font-semibold">0710565929</span> or email{" "}
              <span className="font-semibold">gaticoadvocates@gmail.com</span>.
              We respond within 4 hours with a brief initial assessment at no charge.
            </p>

          </div>

        </div>

        {/* STEP 2 */}
        <div className="group flex gap-6">

          <div className="flex-shrink-0">

            <div className="w-16 h-16 rounded-full bg-[#0B3D91] text-white flex items-center justify-center text-xl font-bold shadow-lg group-hover:scale-110 transition duration-300">
              02
            </div>

          </div>

          <div>

            <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
              Strategy Meeting <span className="text-yellow-600">(Within 48 Hours)</span>
            </h3>

            <p className="text-gray-600 leading-relaxed">
              Meet us in-person at Plutos House, Suite 6, or through a virtual call.
              We discuss facts, options, risks, and legal costs without pressure.
            </p>

          </div>

        </div>

        {/* STEP 3 */}
        <div className="group flex gap-6">

          <div className="flex-shrink-0">

            <div className="w-16 h-16 rounded-full bg-[#0B3D91] text-white flex items-center justify-center text-xl font-bold shadow-lg group-hover:scale-110 transition duration-300">
              03
            </div>

          </div>

          <div>

            <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
              Engagement Agreement
            </h3>

            <p className="text-gray-600 leading-relaxed">
              You sign a clear retainer agreement outlining scope of work,
              legal fees, timelines, and expectations with zero ambiguity.
            </p>

          </div>

        </div>

        {/* STEP 4 */}
        <div className="group flex gap-6">

          <div className="flex-shrink-0">

            <div className="w-16 h-16 rounded-full bg-[#0B3D91] text-white flex items-center justify-center text-xl font-bold shadow-lg group-hover:scale-110 transition duration-300">
              04
            </div>

          </div>

          <div>

            <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
              Active Representation
            </h3>

            <p className="text-gray-600 leading-relaxed">
              We file pleadings, draft legal documents, negotiate settlements,
              and appear in court while providing weekly progress updates
              or more frequent communication where urgent.
            </p>

          </div>

        </div>

        {/* STEP 5 */}
        <div className="group flex gap-6">

          <div className="flex-shrink-0">

            <div className="w-16 h-16 rounded-full bg-[#0B3D91] text-white flex items-center justify-center text-xl font-bold shadow-lg group-hover:scale-110 transition duration-300">
              05
            </div>

          </div>

          <div>

            <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
              Resolution & Aftercare
            </h3>

            <p className="text-gray-600 leading-relaxed">
              Once the matter is concluded, we advise on post-judgment steps,
              future legal considerations, and securely archive your file
              for future reference if needed.
            </p>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>
{/* ================= FEE PHILOSOPHY ================= */}
<section className="py-28 px-6 md:px-16 bg-white overflow-hidden">

  <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-20 items-center">

    {/* ================= LEFT CONTENT ================= */}
    <div
      data-aos="fade-right"
      className="relative"
    >

      {/* SMALL LABEL */}
      <p className="text-yellow-600 uppercase tracking-[6px] font-semibold mb-4">
        Transparent & Fair
      </p>

      {/* HEADING */}
      <h2 className="text-4xl md:text-5xl font-bold text-[#0B1C39] leading-tight mb-8">
        Fee Philosophy
      </h2>

      {/* INTRO */}
      <p className="text-gray-600 text-lg leading-relaxed mb-12">
        We do not believe in vague legal billing or surprise costs.
        Every engagement is structured with transparency, fairness,
        and clarity from the beginning.
      </p>

      {/* PRICING LIST */}
      <div className="space-y-5">

        {/* ITEM */}
        <div className="group bg-[#F8F8F8] hover:bg-[#0B1C39] transition-all duration-500 rounded-2xl p-6 border border-transparent hover:border-yellow-400">

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">

            <h3 className="text-xl font-bold text-[#0B1C39] group-hover:text-white transition">
              Initial Consultation
            </h3>

            <span className="text-yellow-600 font-semibold">
              Free (First 15 Minutes)
            </span>

          </div>

        </div>

        {/* ITEM */}
        <div className="group bg-[#F8F8F8] hover:bg-[#0B1C39] transition-all duration-500 rounded-2xl p-6 border border-transparent hover:border-yellow-400">

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">

            <h3 className="text-xl font-bold text-[#0B1C39] group-hover:text-white transition">
              Demand Letters / Simple Drafting
            </h3>

            <span className="text-yellow-600 font-semibold">
              KES 2,000 – 5,000
            </span>

          </div>

        </div>

        {/* ITEM */}
        <div className="group bg-[#F8F8F8] hover:bg-[#0B1C39] transition-all duration-500 rounded-2xl p-6 border border-transparent hover:border-yellow-400">

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">

            <h3 className="text-xl font-bold text-[#0B1C39] group-hover:text-white transition">
              Conveyance Services
            </h3>

            <span className="text-yellow-600 font-semibold">
              1% of Property Value or Flat Rate
            </span>

          </div>

        </div>

        {/* ITEM */}
        <div className="group bg-[#F8F8F8] hover:bg-[#0B1C39] transition-all duration-500 rounded-2xl p-6 border border-transparent hover:border-yellow-400">

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">

            <h3 className="text-xl font-bold text-[#0B1C39] group-hover:text-white transition">
              Civil Litigation
            </h3>

            <span className="text-yellow-600 font-semibold">
              Retainer + Court Appearance Fees
            </span>

          </div>

        </div>

        {/* ITEM */}
        <div className="group bg-[#F8F8F8] hover:bg-[#0B1C39] transition-all duration-500 rounded-2xl p-6 border border-transparent hover:border-yellow-400">

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">

            <h3 className="text-xl font-bold text-[#0B1C39] group-hover:text-white transition">
              Will Drafting
            </h3>

            <span className="text-yellow-600 font-semibold">
              KES 5,000
            </span>

          </div>

        </div>

        {/* ITEM */}
        <div className="group bg-[#F8F8F8] hover:bg-[#0B1C39] transition-all duration-500 rounded-2xl p-6 border border-transparent hover:border-yellow-400">

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">

            <h3 className="text-xl font-bold text-[#0B1C39] group-hover:text-white transition">
              Business Registration
            </h3>

            <span className="text-yellow-600 font-semibold">
              KES 7,500 Inclusive of Govt Fees
            </span>

          </div>

        </div>

        {/* ITEM */}
        <div className="group bg-[#F8F8F8] hover:bg-[#0B1C39] transition-all duration-500 rounded-2xl p-6 border border-transparent hover:border-yellow-400">

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">

            <h3 className="text-xl font-bold text-[#0B1C39] group-hover:text-white transition">
              Divorce (Uncontested)
            </h3>

            <span className="text-yellow-600 font-semibold">
              KES 30,000
            </span>

          </div>

        </div>

      </div>

      {/* FOOTNOTE */}
      <div className="mt-10 border-l-4 border-yellow-500 pl-6">

        <p className="text-gray-600 leading-relaxed text-lg">
          No hidden charges. All court fees, stamp duty,
          search fees, and disbursements are pre-disclosed,
          with official receipts shared for full accountability.
        </p>

      </div>

    </div>

    {/* ================= RIGHT IMAGE ================= */}
    <div
      data-aos="fade-left"
      className="relative"
    >

      {/* IMAGE CONTAINER */}
      <div className="relative rounded-[32px] overflow-hidden shadow-2xl group">

        <img
          src={feeImage}
          alt="Fee Philosophy"
          className="w-full h-[850px] object-cover group-hover:scale-105 transition duration-700"
        />

        {/* FLOATING CARD */}
        <div className="absolute bottom-8 left-8 right-8 bg-white/90 backdrop-blur-md rounded-2xl p-8 shadow-2xl border border-white/40">

          <p className="text-yellow-600 uppercase tracking-[4px] text-xs font-semibold mb-3">
            Our Promise
          </p>

          <h3 className="text-2xl font-bold text-[#0B1C39] mb-4">
            Transparent Legal Pricing
          </h3>

          <p className="text-gray-700 leading-relaxed">
            Clear retainers. Honest estimates. No surprise invoices.
            Legal representation built on trust and accountability.
          </p>

        </div>

      </div>

      {/* DECORATIVE ACCENT */}
      <div className="absolute -top-8 -right-8 w-40 h-40 bg-yellow-400/20 rounded-full blur-3xl"></div>

    </div>

  </div>

</section>


<section
  className="relative h-[60vh] bg-fixed bg-center bg-cover flex items-center justify-center"
  style={{
    backgroundImage: `url(${aboutparallax})`,
  }}
>

  {/* DARK OVERLAY */}
  <div className="absolute inset-0 bg-black/60"></div>

  {/* CONTENT */}
  <div className="relative z-10 text-center px-6 max-w-4xl">

    <p className="text-yellow-500 uppercase tracking-[6px] mb-6 font-semibold">
      Excellence In Legal Practice
    </p>

    <h2 className="text-4xl md:text-6xl font-bold text-white leading-tight">
      Justice. Integrity. Commitment.
    </h2>

    <p className="text-gray-200 mt-6 text-lg leading-relaxed">
      Delivering strategic legal solutions with professionalism,
      precision, and unwavering dedication to our clients.
    </p>

  </div>

</section>
<CoreValues />
<PracticeAreas />


     {/* ================= TESTIMONIALS + CTA ================= */}
<section className="relative mt-40 pt-[58rem] md:pt-60 pb-20 bg-[#0B3D91] text-white px-6 overflow-visible">
  {/* SECTION HEADING */}
  <div className="absolute left-1/2 -top-44 md:-top-52 -translate-x-1/2 text-center w-full px-6">
    <p className="text-yellow-400 uppercase tracking-[6px] font-semibold mb-4">
      Why Nakuru Trusts GATI & CO.
    </p>
  </div>

  {/* ================= FLOATING TESTIMONIAL CARDS ================= */}
  <div className="absolute left-1/2 -top-20 md:-top-28 -translate-x-1/2 w-full max-w-7xl px-6">

    <div className="grid md:grid-cols-3 gap-8">

      {/* CARD 1 */}
      <div className="bg-white rounded-[28px] p-8 shadow-2xl hover:-translate-y-2 transition-all duration-500 border border-gray-100">

        {/* QUOTE ICON */}
        <div className="text-6xl leading-none text-yellow-500 mb-4">
          “
        </div>

        {/* TEXT */}
        <p className="text-gray-600 leading-relaxed mb-6">
          They handled my land succession in under 3 months — my previous lawyer took 2 years.
        </p>

        {/* CLIENT */}
        <div className="border-t pt-4">

          <h4 className="font-bold text-[#0B1C39]">
            Farmer, Njoro
          </h4>

        </div>

      </div>

      {/* CARD 2 */}
      <div className="bg-white rounded-[28px] p-8 shadow-2xl hover:-translate-y-2 transition-all duration-500 border border-gray-100">

        <div className="text-6xl leading-none text-yellow-500 mb-4">
          “
        </div>

        <p className="text-gray-600 leading-relaxed mb-6">
          Gati & Co. saved my business from a fraudulent supplier.
          The demand letter was so tight, they settled within a week.
        </p>

        <div className="border-t pt-4">

          <h4 className="font-bold text-[#0B1C39]">
            Retailer, Nakuru CBD
          </h4>

        </div>

      </div>

      {/* CARD 3 */}
      <div className="bg-white rounded-[28px] p-8 shadow-2xl hover:-translate-y-2 transition-all duration-500 border border-gray-100">

        <div className="text-6xl leading-none text-yellow-500 mb-4">
          “
        </div>

        <p className="text-gray-600 leading-relaxed mb-6">
          I called on a Friday about an urgent arrest.
          They had bail papers ready by Monday morning.
          Real pros.
        </p>

        <div className="border-t pt-4">

          <h4 className="font-bold text-[#0B1C39]">
            Transport Operator, Salgaa
          </h4>

        </div>

      </div>

    </div>

  </div>

  {/* ================= CTA CONTENT ================= */}
  <div className="max-w-4xl mx-auto text-center">

    

    {/* HEADING */}
    <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
      Need Legal Assistance?
    </h2>

    {/* TEXT */}
    <p className="text-gray-200 text-lg leading-relaxed max-w-2xl mx-auto">
      Get in touch with our legal team for strategic, responsive,
      and client-focused legal representation tailored to your needs.
    </p>

    {/* BUTTON */}
    <Link
      to="/contact"
      className="inline-flex items-center justify-center mt-10 bg-white text-[#0B3D91] px-8 py-4 rounded-xl font-semibold hover:bg-gray-100 hover:scale-105 transition-all duration-300 shadow-xl"
    >
      Contact Us
    </Link>

  </div>

</section>
    </>
  );
}

export default About;